import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { TrackRecord } from "@/components/site/TrackRecord";
import { Gallery } from "@/components/site/Gallery";
import { News } from "@/components/site/News";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { Loader2 } from "lucide-react";

export default function Landing() {
  useLenis();
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/content/all`)
      .then((r) => setContent(r.data))
      .catch(() => setContent({ team: [], services: [], partners: [], stats: [], albums: [], news: [], settings: {} }));
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen grid place-items-center bg-navy text-white">
        <Loader2 className="w-8 h-8 animate-spin text-cyan" />
      </div>
    );
  }

  const s = content.settings || {};

  return (
    <div className="grain relative bg-navy text-white">
      <Header />
      <main>
        <Hero settings={s} />
        <Marquee />
        <About settings={s} team={content.team} />
        <Services services={content.services} whatsappNumber={s.whatsapp_number} />
        <TrackRecord stats={content.stats} partners={content.partners} />
        <Gallery albums={content.albums} />
        <News news={content.news} />
        <Contact settings={s} categories={content.categories} />
      </main>
      <Footer settings={s} />
      <WhatsAppFloat number={s.whatsapp_number} />
    </div>
  );
}